
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
            style="background-image: url(../../assets/xamerinbanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 20px;">
                    <h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Xamarin Application Development</h1>
                    <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">
                        We at WebSoulLabs uses Xamarin to develop applications using common codes across various platforms.
                            
                    </p>
                
                </div>
             </div>
        </div>
    </div>
    </div> 

    
<!--Paragraph part code-->

    <div class="uk-container">
        <h2 class="uk-text-center uk-padding" style="font-weight: 600;"><span>Xamarin Application Development </span></h2>
    
        <p class="uk-text-medium uk-text-justify">Xamarin is an open-source platform for building modern and tremendous applications for iOS, Android, and Windows with .NET. Xamarin is an abstraction layer that takes care communication of shared code with underlying platform code.  This pattern provides developers to write all of their business logic in a single language but achieve native performance, look, and feel on each platform.</p>
             <p class="uk-text-medium  uk-text-justify">Xamarin allows developers to share an average of 90% of their application across platforms. Apps can be developed on Windows and macOS and run on iOS, Android, macOS, watchOS, and more. Xamarin runs in a managed environment that provides advantage such as memory allocation and garbage collection. Through Xamarin, we develop a mobile applications whose look and feel is entirely native.</p>
    </div>
    
    <!--Paragraph part code ends-->
    
        <div class="uk-container">
          
              <h1 class="uk-text-center  uk-padding">Why Xamarin App Development for Android and iOS apps?</h1>
              
              <div class="uk-column-1-2@s">
      
                  
                  <p class="uk-text-medium uk-text-justify">Xamarin is an open-source, cross-platform application development framework, Xamarin is supported by Microsoft. It uses C# language and based on .NET framework to develop mobile applications that can seamlessly run across prevalent OS like Android and iOS. Xamarin app development enables to attach all the native access to platform-specific capabilities like ARKit (iOS) or Multi-Window (Android). Xamarin enables application developers to use common coding across various platforms. Code reuse feature gives Xamarin an edge over its peers. Xamarin development services provides reduced development time and better performance of feature-rich apps on Android OS. Xamarin app development is fast and simple with code sharing and other features.development time for Xamarin-powered apps is quite less as compared to native app development. That's why Xamarin remains the preferred choice all the time.</p>
                  <img data-src="assets/img/xam/x.jpg" style="width:580px; height:350px" alt="xamarin" uk-img>
      
              </div>
        </div>
    

    <br>
    <div class="uk-section  uk-padding" style="background-color: #135796; padding-bottom: 0px;">
        <div class="uk-container uk-container-large ">
            <h1 class="uk-text-center" style="color: snow;">Utility of Xamarin </h1>
            <p class="uk-text-center uk-text-medium" style="color: snow;font-size: 20px;">	
                Xamarin can help developers to come up with awesome Android  and iOS apps
                </p>
            <br>   
            <div class="uk-grid-match uk-grid-collapse uk-child-width-expand@s  uk-padding uk-text-center"style="padding-top: 20px; padding-bottom: 20px;" uk-grid>
            <div>
                <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                    <div class="pa">
                        <span class="text-white">
                            <img src="/assets/img/xam/ap.png" width="60" height="60" alt="svg" style="padding-top: 15px;"></span>
                        
                        <p class="uk-text-justify uk-text-medium" style="color: snow;">
                            Xamarin integrates with thousands of third-party libraries including Google Play services, Facebook, Google APIs for iOS and Android.</p>
                    </div>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-muted  uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                    <div class="pa1">
                        <span class="text-white">
                            <img src="../../assets/img/xam/hk.png" width="60" height="60" alt="svg" style="padding-top: 15px"></span>
                        
                        <p class=" uk-text-justify uk-text-medium" style="color: snow;">
                            It allows developers to create customized Android apps by using C# code base that can be shared with iOS also.</p>
                    </div>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-muted uk-card-body" style="padding-top: 0px; padding-bottom: 0px;">
                    <div class="pa2">
                        <span class="text-white">
                            <img src="../../assets/img/xam/cc.png" width="60" height="60" alt="svg" style="padding-top: 15px"></span>
                        
                        <p class=" uk-text-justify uk-text-medium" style="color: snow;">
                            Developers can easily use rich and effective features of Xamarin to get the advantage of a native UI for applications.</p>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>




    <h1 class="uk-text-center"><span>Related Services</span></h1>
<BR><BR>
    
<div class="uk-container">
    <div class="uk-grid-small  uk-child-width-1-2@s uk-child-width-1-4@m  uk-flex-center uk-grid-match" uk-grid>
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
               
                <img class=" uk-align-center" src="assets/icons/ig1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">IPhone App<br> Development</h4>
        
            </div>
        </div>
       
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">
                <img class="uk-border-pill uk-align-center" src="assets/icons/mobileg1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Mobile App<br> Development</h4>
            
            
            </div>
        </div>
      

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/gapg1.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">PhoneGap App<br> Development</h4>
            </div>
        </div>

        <div>
       
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/xamaring10.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Xamarin App<br> Development</h4>

           
            </div>
        </div>

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/cross.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Cross Platform App Development</h4>

           
            </div>
        </div>

       
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium"  style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/swiftg9.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Swift App<br> Development</h4>

            </div>
        </div>
       
    </div>

</div>




<br><br>
    <br>

    <h1 class="uk-text-center"><span>Technology Stack</span></h1>
    <br><br>
    
    <div class="uk-container">
        <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
   
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/ss.jpg" width="160" height="160"
                        alt="Border pill">
                    <h4 class="uk-text-center">Swift</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/aa.jpg" width="140" height="140"
                        alt="Border pill">
                    <h4 class="uk-text-center">Android</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/jv.png" width="110" height="110"
                        alt="Border pill">
                    <h4 class="uk-text-center">Java</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/ii.png" width="100" height="100"
                        alt="Border pill">
                    <h4 class="uk-text-center">Ios</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/kkk.jpg" width="170" height="170"
                        alt="Border pill">
                    <h4 class="uk-text-center">Kotlin</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/fb.png" width="100" height="100"
                        alt="Border pill">
                    <h4 class="uk-text-center">Fabric</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/xx.png" width="100" height="100"
                        alt="Border pill">
                    <h4 class="uk-text-center">Xamarin</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/rj.png" width="150" height="150"
                        alt="Border pill">
                    <h4 class="uk-text-center">Reack Js</h4>
                </div>
            </div>
        </div>
        <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/aws.png" width="130" height="130"
                        alt="Border pill">
                    <h4 class="uk-text-center">AWS</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/fl.png" width="100" height="100"
                        alt="Border pill">
                    <h4 class="uk-text-center">Flutter</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/bbn.png" width="120" height="120"
                        alt="Border pill">
                    <h4 class="uk-text-center">Backbone</h4>
                </div>
            </div>
            <div>
    
    
                <div class="uk-placeholder uk-panel uk-padding">
    
                    <img class="uk-border-pill uk-align-center" src="assets/img/em.png" width="100" height="100"
                        alt="Border pill">
                    <h4 class="uk-text-center">Ember</h4>
                </div>
            </div>
        </div>
    </div>
<br><br>
<br>
    
    

